import { createFileRoute } from '@tanstack/react-router'
import { LegacyLocaleShim } from '~/components/marketing/legacy-locale-shim'
import { TermsPage } from '~/components/marketing/terms-page'

const SITE_URL = 'https://planno.app'
const CANONICAL = '/termos-de-uso'

export const Route = createFileRoute('/pt/termos-de-uso')({
  component: PtTermsShim,
  head: () => ({
    links: [{ href: `${SITE_URL}${CANONICAL}`, rel: 'canonical' }],
    meta: [{ content: 'noindex,follow', name: 'robots' }],
  }),
})

function PtTermsShim() {
  return (
    <LegacyLocaleShim canonicalPath={CANONICAL}>
      <TermsPage />
    </LegacyLocaleShim>
  )
}
